export default "__VITE_ASSET__BHm6Itf5__"